// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"4af02abf","321":"4b7162c9","330":"a294057f","396":"2baa1643","421":"25b1d5ea","655":"d3e4275c"}[chunkId] + ".chunk.css";
};